var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        filterable: "",
        remote: "",
        clearable: "",
        multiple: "",
        "remote-method": _vm.loadTicketUserList,
        placeholder: "工单所属项目"
      },
      on: { clear: _vm.onClear, focus: _vm.onFocus, change: _vm.onChange },
      model: {
        value: _vm.projectIds,
        callback: function($$v) {
          _vm.projectIds = $$v
        },
        expression: "projectIds"
      }
    },
    _vm._l(_vm.projectList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.name, value: item.id }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78f77936", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f77936","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketProjectSelect.vue
// module id = 994
// module chunks = 75